import classnames from "classnames";
import Button from '@mui/material/Button';
import { useHistory, useLocation } from "react-router-dom";
import { Navbar } from "reactstrap";
import LogoutIcon from '@mui/icons-material/Logout';
import { Auth } from "../../Api/Auth/AuthService";
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
import { EEScorecardAtom } from "../../../State/EEScorecard.Atom";
import moment from "moment";
import { isNullOrEmpty } from "../../Model/helpers";
import { ScorecardAtom } from "../../../State/Scorecard.Atom";
import { Box, Grid, Typography } from "@mui/material";
import { coreTokenAtom, tokenAtom } from "../../../State/Token.Atom";
import { useEffect } from "react";
import React from "react";
import { ConsolidationAtom } from "../../../State/Consolidation.Atom";
import { VerificationCompanyAtom } from "../../../State/VerificationCompany.Atom";
import { WSPScorecardAtom } from "../../../State/WSPScorecard.Atom";
import { OrganisationAtom } from "../../../State/Organisation.Atom";
import { BBBEEScorecardAtom } from "../../../State/BBBEEScorecard.Atom";
import { UserAtom } from "../../../State/user.Atom";
import { ClientRegistrationAtom } from "../../../State/Advisory/ClientRegistration.Atom";

interface IProps {
    handleMiniClick: () => void;
    pageTitle: string;
}

export function TopNavbar(props: IProps) {
    const history = useHistory();
    const scorecard = useRecoilValue(EEScorecardAtom);
    const verificationCompany = useRecoilValue(VerificationCompanyAtom);
    const wspScorecard = useRecoilValue(WSPScorecardAtom);

    const color = "navbar-transparent";

    const resetScorecard = useResetRecoilState(ScorecardAtom);
    const resetScorecardType = useResetRecoilState(ConsolidationAtom);
    const resetScorecardData = useResetRecoilState(EEScorecardAtom);
    const resetVerificationCompany = useResetRecoilState(VerificationCompanyAtom);
    const resetWSPScorecard = useResetRecoilState(WSPScorecardAtom);
    const resetClientRegistration = useResetRecoilState(ClientRegistrationAtom);
    const resetOrganisation = useResetRecoilState(OrganisationAtom);
    const resetBBBEEScorecard = useResetRecoilState(BBBEEScorecardAtom);
    const resetUser = useResetRecoilState(UserAtom);
    const currentUser = useRecoilValue(UserAtom);

    const [token, setToken] = useRecoilState<string>(tokenAtom);
    const [coreToken, setCoreToken] = useRecoilState<string>(coreTokenAtom);

    const location = useLocation();
    const [isEEModule, setIsEEModule] = React.useState(false);
    const [isVerificationCompany, setIsVerificationCompany] = React.useState(false);
    const [isWSPModule, setIsWSPModule] = React.useState(false);
    const [isOrganisationModule, setIsOrganisationModule] = React.useState(false);

    useEffect(() => {
        setIsEEModule(false);
        setIsVerificationCompany(false);
        setIsWSPModule(false);
        if (location.pathname.includes('/ee/')) {
            setIsEEModule(true);
        }
        else if (location.pathname.includes('/company/')) {
            setIsVerificationCompany(true);
        }
        else if (location.pathname.includes('/wsp/')) {
            setIsWSPModule(true);
        }
        else if (location.pathname.includes('/organisation/')) {
            setIsOrganisationModule(true);
        }
        else if (location.pathname.includes('/bee/scorecard')) {
            return;
        }
        else if (location.pathname.includes('/advisory/')) {
            return;
        }
        else {
            setIsEEModule(false);
            setIsVerificationCompany(false);
            setIsWSPModule(false);
            resetScorecard();
            resetScorecardData();
            resetScorecardType();
            resetWSPScorecard();
            resetClientRegistration();
            resetBBBEEScorecard();
            resetOrganisation();
            resetVerificationCompany();
        }
    }, [location]);  // eslint-disable-line react-hooks/exhaustive-deps

    const handleLogout = async () => {
        try {
            localStorage.removeItem('coreToken');
            localStorage.removeItem('accessToken');
            setToken('');
            setCoreToken('');
            sessionStorage.clear();
            await Auth.logout().then(() => {
                resetScorecard();
                resetScorecardData();
                resetScorecardType();
                resetVerificationCompany();
                resetWSPScorecard();
                resetClientRegistration();
                resetOrganisation();
                resetBBBEEScorecard();
                resetUser();
                history.push('/login');
            })
        } catch (error) {
            console.log(error)
        }
    }
    const reportPeriodDateFrom = moment(scorecard.ReportPeriodDateFrom).format("DD MMMM YYYY");
    const reportPeriodDateTo = moment(scorecard.ReportPeriodDateTo).format("DD MMMM YYYY");

    return (
        <>
            <Navbar
                className={classnames("navbar-absolute fixed-top", color)}
                expand="lg"
            >
                {(currentUser.isClient || currentUser.hasAuditRole) &&
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundImage: `url("data:image/png;base64,${currentUser.verificationAgencyBanner}")`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            boxShadow: 'inset -50px 0 50px -50px #f4f3ef, inset 50px 0 50px -50px #f4f3ef',
                        }}
                    />
                }
                <div className="navbar-minimize">
                    <Button
                        sx={{ borderRadius: 28 }}
                        color="primary"
                        id="minimizeSidebar"
                        onClick={props.handleMiniClick}
                        variant="contained"
                    >
                        <i
                            className={`nc-icon nc-minimal-right text-center visible-on-sidebar-mini`}
                        />
                        <i
                            className={`nc-icon nc-minimal-left text-center visible-on-sidebar-regular`}
                        />
                    </Button>
                </div>
                <div className="navbar-wrapper">
                    {isEEModule &&
                        <Grid container spacing={2}>
                            <Grid item>
                                <div style={{ width: '120px', height: '40px' }}>
                                    <img style={{ width: '100%', height: '100%' }} alt="EE123" src={`${process.env.PUBLIC_URL}/img/EE123_Logo.png`} />
                                </div>
                            </Grid>
                            <Grid item>
                                {!isNullOrEmpty(scorecard.ScorecardName) &&
                                    <Box display='flex' flexDirection='column'
                                        justifyContent="center"
                                        alignItems="start"
                                        mt={0.2}>
                                        <Typography variant="caption" fontWeight='bolder' fontSize='0.7em' className="d-none d-md-block">Scorecard Name: {scorecard.ScorecardName}</Typography>
                                        <Typography variant="caption" fontWeight='bolder' fontSize='0.7em' className="d-none d-md-block">Reporting Period: {reportPeriodDateFrom} To {reportPeriodDateTo}</Typography>
                                    </Box>
                                }
                            </Grid>
                        </Grid>
                    }
                    {
                        isVerificationCompany && !isNullOrEmpty(verificationCompany.company) &&
                        <Box mt={0.2} display="flex" flexDirection="column" alignItems="center">
                            <Typography variant="h5" fontWeight="bolder" className="d-none d-md-block">
                                {verificationCompany.company}&nbsp;
                            </Typography>
                            {verificationCompany.registrationNumber && (
                                <div className="d-none d-md-flex">
                                    <Typography variant="caption">
                                        (REG: {verificationCompany.registrationNumber}
                                        {verificationCompany.vatNumber ? `, VAT: ${verificationCompany.vatNumber}` : ''})
                                    </Typography>
                                </div>
                            )}
                            {!verificationCompany.registrationNumber && verificationCompany.vatNumber && (
                                <div className="d-none d-md-flex">
                                    <Typography variant="caption">
                                        (VAT: {verificationCompany.vatNumber})
                                    </Typography>
                                </div>
                            )}
                        </Box>

                    }
                    {isWSPModule &&
                        <Grid container spacing={2}>
                            <Grid item>
                                <div style={{ width: '120px', height: '30px', marginTop: wspScorecard.wspScorecardName ? '8px' : '0' }}>
                                    <img style={{ width: '100%', height: '100%' }} alt="EE123" src={`${process.env.PUBLIC_URL}/img/WSP123_logo.png`} />
                                </div>
                            </Grid>
                            <Grid item>
                                {!isNullOrEmpty(wspScorecard.wspScorecardName) &&
                                    <Box display='flex' flexDirection='column'
                                        justifyContent="center"
                                        alignItems="start"
                                        mt={0.2}>
                                        <Typography variant="caption" fontWeight='bolder' fontSize='0.7em' className="d-none d-md-block">Organisation: {wspScorecard.organisationName}</Typography>
                                        <Typography variant="caption" fontWeight='bolder' fontSize='0.7em' className="d-none d-md-block">WSP Reporting Period: {wspScorecard.wspReportPeriodDateFrom} To {wspScorecard.wspReportPeriodDateTo}</Typography>
                                        <Typography variant="caption" fontWeight='bolder' fontSize='0.7em' className="d-none d-md-block">ATR Reporting Period: {wspScorecard.atrReportPeriodDateFrom} To {wspScorecard.atrReportPeriodDateTo}</Typography>
                                    </Box>
                                }
                            </Grid>
                        </Grid>
                    }
                </div>
                <Button startIcon={<LogoutIcon />} aria-label="logout" onClick={handleLogout} color="primary" variant={`${isNullOrEmpty(currentUser.verificationAgencyBanner) ? "text" : "contained"}`}>
                    Logout
                </Button>
            </Navbar>
        </>
    );
}
